(function () {
  angular.module("akitabox.serviceRequest", [
    "ui.router",
    "akitabox.constants",
    "akitabox.core.constants",
    "akitabox.core.router",
    "akitabox.serviceRequest.create",
    "akitabox.serviceRequest.detail",
    "akitabox.serviceRequest.list",
    "akitabox.serviceRequest.newList",
  ]);
})();
